import { useState } from 'react';
import axios from 'axios';
import { Button, IconButton, Tooltip, Zoom, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Typography } from '@material-ui/core';
import { Autorenew } from '@material-ui/icons';


interface IProps {
    email: string
}

let GeneratePassword = ({ email }: IProps) => {

    let [isGenerating, setGenerating] = useState(false);
    let [password, setPassword] = useState('');


    let getTempPassword = async () => {
        if (window.confirm("Are you sure that you want to generate new password for this user?") === false)
            return;

        try {
            setGenerating(true);
            setPassword('');

            let res = await axios.get<string>('/api/User/GetTemporaryPassword', { params: { email } });

            setPassword(res.data);

        } catch (err) { }
        finally {
            setGenerating(false);
        }
    }


    return (
        <>
            <Tooltip TransitionComponent={Zoom} title="Generate temporary password">
                <IconButton
                    size="small"
                    disabled={isGenerating}
                    onClick={getTempPassword}
                >
                    {isGenerating ? <CircularProgress size={20} /> : <Autorenew />}
                </IconButton>
            </Tooltip>

            <Dialog
                open={password !== ''}
                maxWidth="sm"
                fullWidth={true}
            >
                <DialogTitle disableTypography>
                    <Typography variant="h4">
                        This is temporary password
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Typography>{password}</Typography>
                </DialogContent>

                <DialogActions>
                    <Button color="secondary" onClick={() => setPassword('')}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default GeneratePassword;